// extracted by mini-css-extract-plugin
module.exports = {"styles":"cardOrders_styles__2l9Yr"};